import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CloseGlyph = /*#__PURE__*/createElement("g", {
  id: "close"
}, /*#__PURE__*/createElement("path", {
  d: "M44.1,42l18.2-18.2c0.6-0.6,0.6-1.5,0-2.1c-0.6-0.6-1.5-0.6-2.1,0L42,39.9L23.8,21.7c-0.6-0.6-1.5-0.6-2.1,0 c-0.6,0.6-0.6,1.5,0,2.1L39.9,42L21.7,60.2c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4L42,44.1l18.2,18.2 c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4c0.6-0.6,0.6-1.5,0-2.1L44.1,42z"
}));
const Close = createSvg({
  name: 'close',
  path: CloseGlyph
});

export default Close;
export { CloseGlyph };
